import { Box } from "@mui/material";
import type { WhatsNewMedia as WhatsNewMediaModel } from "models/whats-new";

/**
 * Renders each release step's screenshot as a single contained background
 * image (Figma: the "What's new in Imagio" media panel is one baked-in
 * screenshot, not composed sub-elements).
 */
export const WhatsNewMedia = ({ media }: { media: WhatsNewMediaModel[] }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--spacing12, 12px)",
        width: "100%",
      }}
    >
      {media.map((item) => (
        <Box
          key={`${item.src}-${item.alt}`}
          role="img"
          aria-label={item.alt}
          sx={{
            height: "176px",
            borderRadius: "var(--radius4, 4px)",
            border: "1px solid var(--alias-stroke-on-white-default, #D9D9D9)",
            backgroundColor: "var(--alias-surface-low, #F2F2F2)",
            backgroundImage: `url(${item.src})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
          }}
        />
      ))}
    </Box>
  );
};
